import InboxComponent from './inbox-component';

export default InboxComponent;
